export default __webpack_public_path__ + "static/media/hilel_yafe-modified.46d980d5.png";